const escapeCsvCell = (val) => {
  const text = String(val ?? "");
  if (/[",\n]/.test(text)) return `"${text.replace(/"/g, '""')}"`;
  return text;
};

const buildCsvBlob = (headers, rows) => {
  const csv = [headers, ...rows]
    .map((line) => line.map(escapeCsvCell).join(","))
    .join("\n");
  return new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
};

const triggerDownload = (blob, filename) => {
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  link.click();
  URL.revokeObjectURL(link.href);
};

function slugify(name) {
  return (name || "bot")
    .replace(/[^\w-]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "")
    .slice(0, 40);
}

export function buildIntentInsightsCsvFilename({ botName, periodDays }) {
  const date = new Date().toISOString().slice(0, 10);
  return `intent-insights-${slugify(botName)}-${periodDays}d-${date}.csv`;
}

export function exportIntentInsightsCsv({ data, botName, periodDays, t }) {
  if (!data) return;

  const headers = ["Section", "Metric", "Value", "Detail"];
  const rows = [];

  rows.push(["Summary", "Period", data.period?.label || `${periodDays} days`, ""]);
  rows.push(["Summary", "Conversations", data.conversationCount ?? 0, ""]);
  rows.push(["Summary", "Visitors", data.visitorCount ?? 0, ""]);
  rows.push(["Summary", "Leads", data.leadCount ?? 0, ""]);
  rows.push(["Summary", "Top intent", data.topIntent?.label || "", `${data.topIntent?.pct ?? 0}%`]);
  rows.push(["Summary", "Negative sentiment", `${data.negativeSentimentPct ?? 0}%`, ""]);
  rows.push(["Summary", "Confidence", data.confidence || "", ""]);

  (data.autoInsights || []).forEach((insight, index) => {
    rows.push([
      "Auto insight",
      `#${index + 1}`,
      insight.headline || "",
      insight.detail || "",
    ]);
  });

  (data.topIntents || []).forEach((intent) => {
    rows.push([
      t("sonic_prospect.intent_insights.top_intents_title"),
      intent.label || "",
      `${intent.pct ?? 0}%`,
      `${intent.count ?? 0} conversations`,
    ]);
  });

  (data.frictionPoints || []).forEach((point) => {
    rows.push([
      t("sonic_prospect.intent_insights.friction_title"),
      point.label || "",
      `${point.pct ?? 0}%`,
      "",
    ]);
  });

  (data.objections || []).forEach((obj) => {
    rows.push([
      t("sonic_prospect.intent_insights.objections_title"),
      obj.label || "",
      obj.mentions ?? 0,
      "",
    ]);
  });

  (data.sentimentTrend || []).forEach((point) => {
    rows.push([
      t("sonic_prospect.intent_insights.sentiment_title"),
      point.date || point.label || "",
      "",
      `pos ${point.positive ?? 0}% / neu ${point.neutral ?? 0}% / neg ${point.negative ?? 0}%`,
    ]);
  });

  triggerDownload(
    buildCsvBlob(headers, rows),
    buildIntentInsightsCsvFilename({ botName, periodDays }),
  );
}
